import { Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { DensityStyleTypes } from 'types'

interface RenderNameCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}
const RenderStringCell: React.FC<RenderNameCellProps> = ({ params, densityStyles }) => {
  const { rowNode, row, value } = params
  const route = `/deals/${row?.PK}/DEAL_${row?.deal_uuid}/agreement`
  //@ts-ignore
  if (rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        pl: densityStyles.padding,
        pt: densityStyles.padding,
        pb: densityStyles.padding,
        pr: densityStyles.padding,
        gap: densityStyles.gap,
        width: '100%',
        backgroundColor: 'transparent',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      <Typography
        sx={{
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontSize: densityStyles.fontSize,
          fontWeight: 400,
          color: row?.isProduct ? 'text.highlight' : 'text.primary',
        }}
      >
        {value}
      </Typography>
    </Box>
  )
}
export default RenderStringCell
